import { RootState } from 'editor/src/store/index';
import getAreaTokenForSpreadName from 'editor/src/store/livePreview/selector/getAreaTokenForSpreadName';

import findSpreadGroundImage from 'editor/src/util/design/findSpreadGroundImage';

const getSpreadMaskImage = (state: RootState, spreadName: string) =>
  findSpreadGroundImage(state.design.spreadMasks, spreadName) ??
  findSpreadGroundImage(state.design.spreadMasks, getAreaTokenForSpreadName(state, spreadName));

export default getSpreadMaskImage;
